// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"08b908c5","496":"ab495d48","703":"ce258b3f"}[chunkId] + ".chunk.js";
};